import { FC } from 'react';
import { useAppSelector } from 'redux/store';
import { useTheme } from 'styled-components';
import { dateConverter, dateShortenFormat } from '@idaho-aeyc/ui-kit';
import { Text } from 'components/Base/Typography';
import { Row, Col } from 'components/Base/Grid';
import { useTranslation } from '@packages/utils';
import { EWorkshopPartType } from 'data/types/workshops.types';
import { TSessionPartCardProps } from './SessionPartCard.types';
import { formatTimeRange } from './formatTimeRange';
import {
  enumPartTypeKeyPrefix,
  flyerSessionsSectionKeyPrefix,
} from '../SeriesPart/Series.data';
import { SInfoItemWrapper } from '../../Flyers.styles';

const SessionPartCard: FC<TSessionPartCardProps> = ({
  color,
  title,
  part,
  sessionDate,
  isChildCareAndPreschool,
  startTime,
  endTime,
  timezone,
}) => {
  const theme = useTheme();
  const flyerLanguage = useAppSelector(state => state.appSlice.flyerLanguage);
  const { t } = useTranslation({
    ...(flyerLanguage && { lng: flyerLanguage }),
  });

  const timeLabel = formatTimeRange(startTime, endTime, timezone);
  let displayValue: string | undefined;
  if (sessionDate?.value) {
    displayValue = timeLabel
      ? `${dateConverter(sessionDate.value, dateShortenFormat)} · ${timeLabel}`
      : sessionDate.value;
  }

  return (
    <SInfoItemWrapper>
      <Row
        wrap={false}
        align="middle"
        justify={part ? 'start' : 'center'}
        gutter={[6, 0]}
      >
        {part && (
          <Col>
            <Text
              fontSize={theme.fontSizeHeading2}
              fontWeight={theme.fontWeightHeavy}
              color={color}
            >
              {`${part} - `}
            </Text>
          </Col>
        )}
        <Col>
          <Text
            fontSize={theme.fontSizeHeading2}
            fontWeight={theme.fontWeightHeavy}
            color={color}
          >
            {title}
            {sessionDate ? ': ' : ''}
            {isChildCareAndPreschool &&
              part ===
                t(`${enumPartTypeKeyPrefix}.${EWorkshopPartType.PART_TWO}`) && (
                <>
                  <br />
                  {t(`${flyerSessionsSectionKeyPrefix}.PART_3_TITLE`)}
                  {sessionDate ? ': ' : ''}
                </>
              )}
          </Text>
        </Col>

        {displayValue && (
          <Col>
            <Text
              color={theme.colorBlackDescription}
              fontWeight={theme.fontWeightRegular}
              fontSize={theme.fontSizeHeading2}
            >
              {displayValue}
            </Text>
          </Col>
        )}
      </Row>
    </SInfoItemWrapper>
  );
};

export default SessionPartCard;
